type Space = `${string}rem`

/* eslint-disable sort-keys */
export type Spaces = {
  '2XS': Space
  XS: Space
  S: Space
  M: Space
  L: Space
  XL: Space
  '2XL': Space
  '3XL': Space
  '4XL': Space
  '5XL': Space
}

const spaces: Spaces = {
  '2XS': '0.25rem',
  XS: '0.5rem',
  S: '1rem',
  M: '1.5rem',
  L: '2rem',
  XL: '3rem',
  '2XL': '4rem',
  '3XL': '5rem',
  '4XL': '6rem',
  '5XL': '8.125rem',
}
export default spaces
